import LeaveInitialBalance from '@/api/hr/leave-initial-balance'
import Employee from '@/api/hr/employee'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employees: [],
  leaveTypes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_EMPLOYEES(state, data) {
    state.employees = data
  },

  RECEIVE_LEAVE_TYPES(state, data) {
    state.leaveTypes = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        cycle_year: attrubutes.year
      },
      attrubutes
    )
    return LeaveInitialBalance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return LeaveInitialBalance.store(data)
  },

  update(context, data) {
    return LeaveInitialBalance.update(data)
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en,employee_name_kh'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  async dataBeforeCreate(context) {
    if (!context.state.leaveTypes.length > 0) {
      let response = await LeaveInitialBalance.leaveType()
      context.commit('RECEIVE_LEAVE_TYPES', response.data)
    }
  }
}
